import React, { createContext, useMemo, useState } from 'react';
import './App.scss';
import { RouterProvider } from "react-router-dom";
import { Router } from './routes/route';
import { Privilege } from './Types';
import { DrawerContextProvider } from './contexts/DrawerContext';
import { useUrfReceiveEvents } from './hooks/urfEvents';

export const XevmpdContext = createContext<{
  privileges: Privilege;
  setPrivileges: React.Dispatch<React.SetStateAction<Privilege>>;
  paginationTotalRecord: number;
  setPaginationTotalRecord: React.Dispatch<React.SetStateAction<number>>;
  paginationobject:{ page: number; pageSize: number };
  setPaginationobject: React.Dispatch<React.SetStateAction<{ page: number; pageSize: number }>>;
  allXevmpdRows: any[];
  setallXevmpdRows: React.Dispatch<React.SetStateAction<any[]>>;
  taskButtonConfig: API.TaskResultProperty | null;
  setTaskButtonConfig: React.Dispatch<React.SetStateAction<API.TaskResultProperty | null>>;
  processRelatedInfo: {[key: string]: any};
  setProcessRelatedInfo: React.Dispatch<React.SetStateAction<{[key: string]: any}>>;
}>({
  privileges: {
    viewprivilege: false,
    editprivilege: false,
    deleteprivilege: false,
    addprivilege: false,
    addackprevilege:false
  },
  setPrivileges: () => {},
  paginationTotalRecord:0,
  setPaginationTotalRecord:() => {},
  paginationobject: { page: 0, pageSize: 50 },
  setPaginationobject: () => {},
  allXevmpdRows:[],
  setallXevmpdRows:()=>{},
  taskButtonConfig: null,
  setTaskButtonConfig: () => {},
  processRelatedInfo: {},
  setProcessRelatedInfo: () => {},
});

const App: React.FC = () => {
  const [privileges, setPrivileges] = useState<Privilege>({
    viewprivilege: false,
    editprivilege: false,
    deleteprivilege: false,
    addprivilege: false,
    addackprevilege:false
  });
  const [paginationTotalRecord,setPaginationTotalRecord]=useState(0);
  const [paginationobject, setPaginationobject] = useState<{ page: number; pageSize: number }>({ page: 0, pageSize: 50 });
  const [allXevmpdRows, setallXevmpdRows] = useState<any[]>([]);  
  const [taskButtonConfig, setTaskButtonConfig] = useState<API.TaskResultProperty | null>(null);
  const [processRelatedInfo, setProcessRelatedInfo] = useState<{[key: string]: any}>({});
  useUrfReceiveEvents();

  const contextValue = useMemo(() => ({privileges, setPrivileges,paginationTotalRecord ,setPaginationTotalRecord,paginationobject,setPaginationobject,allXevmpdRows,setallXevmpdRows,taskButtonConfig, setTaskButtonConfig, processRelatedInfo, setProcessRelatedInfo}), [privileges,paginationTotalRecord ,setPaginationTotalRecord,paginationobject,setPaginationobject,allXevmpdRows,setallXevmpdRows,taskButtonConfig, setTaskButtonConfig, processRelatedInfo, setProcessRelatedInfo]);
  return (
    <DrawerContextProvider>
      <XevmpdContext.Provider value={contextValue}>
        <RouterProvider router={Router} />
      </XevmpdContext.Provider>
    </DrawerContextProvider>
  );
};

export default App;
